'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.load = load;
exports.markAsSeen = markAsSeen;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOTIFICATIONS_LOAD = 'ms/notifications/load';
var NOTIFICATIONS_LOAD_SUCCESS = 'ms/notifications/load_success';
var NOTIFICATIONS_LOAD_FAIL = 'ms/notifications/load_fail';

var NOTIFICATIONS_MARK_SEEN = 'ms/notifications/mark_seen';
var NOTIFICATIONS_MARK_SEEN_SUCCESS = 'ms/notifications/mark_seen_sucess';
var NOTIFICATIONS_MARK_SEEN_FAIL = 'ms/notifications/mark_seen_fail';

var initialState = [];

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case NOTIFICATIONS_LOAD:
      return initialState;

    //     seen: true,
    // [1]        createdAt: '2017-10-24T11:40:47.961Z',
    // [1]        title: 'Notification Title',
    // [1]        text: 'Some text for this notification that is set just to see how it looks in the notification ',
    // [1]        iconUrl: 'https://ddinktqu5prvc.cloudfront.net/asset-phhdoip0/phhdoip_Thumb_thumb.jpg',
    // [1]        scope: 'individual'

    case NOTIFICATIONS_LOAD_SUCCESS:
      // console.log(action.result)
      return action.result.notifications && action.result.notifications.map(function (n) {
        return {
          time: (0, _moment2.default)(n.createdAt).fromNow(),
          message: n.title,
          text: n.text,
          iconUrl: n.iconURI,
          isNew: !n.seen,
          action: n.action,
          assetIds: n.assetIds
        };
      }) || [];
    case NOTIFICATIONS_MARK_SEEN_SUCCESS:
      // console.log(action.result)
      return state.map(function (n) {
        n.isNew = false;
        return n;
      });

    default:
      return state;
  }
}

// Action creators
function load() {
  return function (dispatch, getState) {
    if (!getState().auth.loggedIn) return null;
    if (getState().notifications.length) return null;

    return dispatch({
      types: [NOTIFICATIONS_LOAD, NOTIFICATIONS_LOAD_SUCCESS, NOTIFICATIONS_LOAD_FAIL],
      promise: function promise(client) {
        return client.get('/v1/notifications?count=20');
      }
    });
  };
}

function markAsSeen() {
  return function (dispatch, getState) {
    if (!getState().auth.loggedIn) return null;

    return dispatch({
      types: [NOTIFICATIONS_MARK_SEEN, NOTIFICATIONS_MARK_SEEN_SUCCESS, NOTIFICATIONS_MARK_SEEN_FAIL],
      promise: function promise(client) {
        return client.put('/v1/notifications/seen');
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/notifications.js
// module id = 530
// module chunks = 0